import AxiosService from "./AxiosService";

let DemandeService = {
  getTypes() {
    return AxiosService.get("api/demandes/types");
  },
  getFicheDmPdf(id) {
    return AxiosService.get(`api/demandes/ficheDm/${id}`, {
      responseType: "arraybuffer",
    });
  },
};

export default DemandeService;
